import React from 'react'
import { Form, Checkbox as AntdCheckbox } from 'antd'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'

import styles from './Checkbox.module.scss'

export type CheckboxOption<T> = {
  label: string
  value: T
}

type Props<T> = {
  children?: React.ReactNode
  className?: string
  name?: string
  group?: boolean
  checked?: boolean
  options?: CheckboxOption<T>[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeGroup?: (checked: any) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeSingle?: (checked: any) => void
  value?: CheckboxValueType[]
}

const Checkbox = <T extends string | number>(props: Props<T>) => {
  const {
    children,
    className,
    name,
    group,
    options,
    onChangeGroup,
    onChangeSingle,
    value,
  } = props
  return (
    <>
      {group ? (
        <div className={className}>
          <AntdCheckbox.Group
            className={styles.checkboxGroup}
            options={options}
            onChange={onChangeGroup}
            value={value}
          />
        </div>
      ) : (
        <Form.Item name={name} valuePropName="checked" className={className}>
          <AntdCheckbox
            {...props}
            className={styles.checkbox}
            onChange={onChangeSingle}
          >
            {children}
          </AntdCheckbox>
        </Form.Item>
      )}
    </>
  )
}

export default Checkbox
